import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-slate-900 text-slate-300 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-violet-400 hover:text-violet-300 mb-8">
          <ArrowLeft className="w-4 h-4" />
          Back to CreatorFlow
        </Link>
        
        <h1 className="text-3xl font-bold mb-2 text-white">Privacy Policy</h1>
        <p className="text-slate-500 mb-8">Effective Date: February 2026</p>
        
        <div className="space-y-6 text-slate-400">
          <p>CreatorFlow respects your privacy.</p>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">1. Information We Collect</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Account email and authentication data</li>
              <li>Generated content</li>
              <li>Usage and credit activity</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">2. Payment Information</h2>
            <p>All payments are processed via PayPal. We do not store credit card information.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">3. How We Use Information</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>To provide and improve services</li>
              <li>To manage subscriptions and credits</li>
              <li>To respond to support requests</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">4. Data Storage</h2>
            <p>Your content and account data are stored securely.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">5. Third-Party Services</h2>
            <p>We may use trusted third-party providers (e.g., payment processors, AI APIs).</p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">6. Data Security</h2>
            <p>We implement reasonable measures to protect your data.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">7. Contact</h2>
            <p>
              <a href="mailto:support@creatorflow.website" className="text-violet-400 hover:text-violet-300">
                support@creatorflow.website
              </a>
            </p>
            <p className="mt-1">We typically respond within 24 hours.</p>
          </section>
        </div>
        
        <div className="mt-12 pt-6 border-t border-slate-700 flex gap-6 text-sm">
          <Link to="/terms" className="text-violet-400 hover:text-violet-300">Terms of Service</Link>
          <Link to="/help" className="text-violet-400 hover:text-violet-300">Help & Support</Link>
        </div>
      </div>
    </div>
  );
}
